<template>
    <div class="form_item form_item-w">
        <div class="app_limits">
            <div class="app_limits_title">Граничні рівні:</div>
            <div class="app_limits_box app_limits_box-2" v-if="limits !== null">
                <div class="app_limits_item" v-if="limits.hasOwnProperty('HD')">
                    <p class="app_limits_item_title">Спека</p>
                    <p class="app_limits_item_undertitle"><b>{{ limits.HD.value }}</b> дні</p>
                    <p class="app_limits_item_text sim-only">де максимальна денна температура досягла <b>{{ limits.HD.threshold }}C</b></p>
                </div>
                <div class="app_limits_item" v-if="limits.hasOwnProperty('DR')">
                    <p class="app_limits_item_title">Нестача опадів</p>
                    <p class="app_limits_item_undertitle"><span class="sim-only">менше ніж  </span><b>{{ limits.DR.value }}</b> мм</p>
                    <p class="app_limits_item_text sim-only">сума опадів що перевищує {{ limits.DR.threshold }} мм за добу</p>
                </div>
                <div class="app_limits_item" v-if="limits.hasOwnProperty('XR')">
                    <p class="app_limits_item_title">Злива</p>
                    <p class="app_limits_item_undertitle"><span class="sim-only">більше ніж </span><b>{{ limits.XR.value }}</b> мм</p>
                    <p class="app_limits_item_text sim-only">сума опадів що перевищує {{ limits.XR.threshold }} мм за добу</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LimitsComponent",
    props: {
        limits: null,
    }
}
</script>

<style scoped>

</style>
